import { DeployChannelType } from '@gfe/core/models/deploy-plan-config.model';
import { ICONS } from '@gfe/core/services/icons/icons.service';

export interface ChannelMeta {
  icon: string;
  labelKey: string;
  colorClass: string;
}

const CHANNEL_META: Record<DeployChannelType, ChannelMeta> = {
  [DeployChannelType.EMAIL]: {
    icon: ICONS.envelope,
    labelKey: 'features.plan.deploy.channels.EMAIL',
    colorClass: 'bg-info-soft text-info-hover'
  },
  [DeployChannelType.MULTIPLE_EMAILS]: {
    icon: ICONS.users,
    labelKey: 'features.plan.deploy.channels.MULTIPLE_EMAILS',
    colorClass: 'bg-accent-interactive text-accent-main'
  },
  [DeployChannelType.WEBHOOK]: {
    icon: ICONS.link,
    labelKey: 'features.plan.deploy.channels.WEBHOOK',
    colorClass: 'bg-optional-soft text-optional-hover'
  },
  [DeployChannelType.GEDMOUV]: {
    icon: ICONS.arrowSquareOut,
    labelKey: 'features.plan.deploy.channels.GEDMOUV',
    colorClass: 'bg-warning-soft text-warning-hover'
  },
  [DeployChannelType.GAEL]: {
    icon: ICONS.arrowSquareOut,
    labelKey: 'features.plan.deploy.channels.GAEL',
    colorClass: 'bg-success-soft text-success-hover'
  }
};

export function getChannelMeta(channel: DeployChannelType): ChannelMeta {
  return (
    CHANNEL_META[channel] ?? {
      icon: ICONS.questionMark,
      labelKey: 'features.plan.deploy.channels.UNKNOWN',
      colorClass: 'bg-interactive text-text-secondary'
    }
  );
}
